import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { SocialPlatform } from "../data/socialPlatforms";

export interface SocialAccount {
  platform: SocialPlatform;
  handle: string;        // @marcio_r3
  accountId?: string;    // 26404075672580827
  accessToken?: string;
  refreshUrl?: string;
  expiresAt?: number;
  notes?: string;
}

interface State {
  /** clientId → array de contas */
  accounts: Record<string, SocialAccount[]>;
  setAccounts: (clientId: string, list: SocialAccount[]) => void;
  upsertAccount: (clientId: string, account: SocialAccount) => void;
  removeAccount: (clientId: string, platform: SocialPlatform, handle: string) => void;
}

const envJson = (() => {
  try {
    const raw = (import.meta as any).env?.VITE_SOCIAL_CREDS_JSON as string | undefined;
    if (!raw) return {};
    return JSON.parse(raw);
  } catch { return {}; }
})();

export const useSocialCreds = create<State>()(
  persist(
    (set) => ({
      accounts: envJson,
      setAccounts: (clientId, list) => set(s => ({
        accounts: { ...s.accounts, [clientId]: list }
      })),
      upsertAccount: (clientId, account) => set(s => {
        const cur = s.accounts[clientId] ?? [];
        const idx = cur.findIndex(a =>
          a.platform === account.platform && a.handle === account.handle
        );
        const next = [...cur];
        if (idx >= 0) next[idx] = account;
        else next.push(account);
        return { accounts: { ...s.accounts, [clientId]: next } };
      }),
      removeAccount: (clientId, platform, handle) => set(s => ({
        accounts: {
          ...s.accounts,
          [clientId]: (s.accounts[clientId] ?? []).filter(a =>
            !(a.platform === platform && a.handle === handle))
        }
      }))
    }),
    {
      name: "agencia-vpc-socialcreds-v1",
      merge: (persisted: any, current: any) => {
        // mescla: dados do env entram em clientes que ainda não têm conta salva
        const merged = { ...current, ...(persisted ?? {}) };
        const accounts = { ...(persisted?.accounts ?? {}) };
        Object.entries(envJson as Record<string, SocialAccount[]>).forEach(([cid, list]) => {
          if (!accounts[cid] || accounts[cid].length === 0) accounts[cid] = list;
        });
        return { ...merged, accounts };
      }
    }
  )
);
